import { getEpoch } from "../DateFormatter";

const FIRST = "1st Semester";
const SECOND = "2nd Semester";

const findTimePeriod = (timePeriodDto, name) => (timePeriodDto || []).find((tp) => tp?.name === name);

const matchesGradingProfile = (w, timePeriodKey) =>
    w?.action === "GRADING_PROFILE" && Number(w.differentiator) === Number(timePeriodKey);

/** Prefer LOCATION override over DEFAULT when both exist for the same semester. */
const findGradingProfileWindow = (actionWindows, timePeriodKey) => {
    const matches = (actionWindows || []).filter((w) => matchesGradingProfile(w, timePeriodKey));
    if (!matches.length) return undefined;
    return matches.find((w) => w?.whoType === "LOCATION") || matches[0];
};

const isPastGradingProfileEnd = (actionWindows, timePeriodKey, nowEpoch) => {
    if (timePeriodKey == null || nowEpoch == null) return false;
    const window = findGradingProfileWindow(actionWindows, timePeriodKey);
    if (!window?.endDate) return false;
    const end = getEpoch(window.endDate);
    if (end == null || Number.isNaN(end)) return false;
    return nowEpoch >= end;
};

/**
 * Which semester's School Report Card Statistics to show on the current school year.
 * null = hide the component (grading window still open for 1st, etc.).
 *
 * @param {Object} params
 * @param {Array} [params.actionWindows]
 * @param {Array} [params.timePeriodDto]
 * @param {string} [params.currentPeriodName]
 * @param {number} [params.nowEpoch]
 * @returns {"1st Semester"|"2nd Semester"|null}
 */
export const resolveCurrentYearStatsSemester = ({
    actionWindows = [],
    timePeriodDto = [],
    currentPeriodName,
    nowEpoch
} = {}) => {
    const first = findTimePeriod(timePeriodDto, FIRST);
    const second = findTimePeriod(timePeriodDto, SECOND);

    if (isPastGradingProfileEnd(actionWindows, second?.key, nowEpoch)) {
        return SECOND;
    }
    if (currentPeriodName === SECOND || isPastGradingProfileEnd(actionWindows, first?.key, nowEpoch)) {
        return FIRST;
    }
    return null;
};
